import Service from '@ember/service';

import { once } from '@ember/runloop';
import { service } from '@ember/service';

export default class FileGalleryService extends Service {
  @service store;

  _findRecordsByCategoryMeta;

  findRecordsByCategory(categories) {
    if (!this._findRecordsByCategoryMeta) {
      const meta = this._findRecordsByCategoryMeta = {
        categories: [],
      };
      meta.promise = new Promise((res, rej) => {
        meta.resolve = res;
        meta.reject = rej;
      });
    }
    this._findRecordsByCategoryMeta.categories = Array.from(
      new Set(this._findRecordsByCategoryMeta.categories.concat(categories)),
    );
    once(this, '_findRecordsByCategory');
    return this._findRecordsByCategoryMeta.promise;
  }

  _findRecordsByCategory() {
    if (this.store.isDestroyed) {
      return Promise.reject();
    }
    const meta = this._findRecordsByCategoryMeta;
    if (meta && meta.categories && meta.categories.length) {
      const { categories, resolve, reject } = meta;
      const queryParams = {
        include: 'field_file',
        'filter[category][group][conjunction]': 'OR',
      };
      categories.forEach((category, i) => {
        if (!category) {
          return;
        }
        const filter = `filter[category${i}][condition]`;
        Object.assign(queryParams, {
          [`${filter}[memberOf]`]: 'category',
          [`${filter}[path]`]:     'field_category',
          [`${filter}[operator]`]: '=',
          [`${filter}[value]`]:    category,
        });
      });
      const result = this.store.query('file-gallery', queryParams);
      result.catch((...args) => {
        once(reject, reject, ...args);
      });
      result.then((...args) => {
        once(resolve, resolve, ...args);
      });
    } else if (meta) {
      meta.resolve([]);
    }
    this._findRecordsByCategoryMeta = null;
  }
}
